import { render, staticRenderFns } from "./goods-data.vue?vue&type=template&id=45736696&scoped=true&"
import script from "./goods-data.vue?vue&type=script&lang=js&"
export * from "./goods-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45736696",
  null
  
)

export default component.exports